import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CookieBanner from "./components/ui/CookieBanner";
import MaxChatWidget from "./components/ui/MaxChatWidget";

// Главная и часто-посещаемые страницы — синхронные (быстрый first paint, нет flash'а)
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import TariffsPage from "./pages/TariffsPage";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";

// Авторизованные/тяжёлые/редкие — code-split через React.lazy
// AdminPage (~1700 строк) + CabinetPage + BookingPage загружаются only on demand
const CabinetPage = lazy(() => import("./pages/CabinetPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const BookingPage = lazy(() => import("./pages/BookingPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const ContactsPage = lazy(() => import("./pages/ContactsPage"));
const HowItWorksPage = lazy(() => import("./pages/HowItWorksPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const OfferPage = lazy(() => import("./pages/OfferPage"));
const RulesPage = lazy(() => import("./pages/RulesPage"));
const RecurringInfoPage = lazy(() => import("./pages/RecurringInfoPage"));

import ScrollToTopOnNav from "./components/ui/ScrollToTopOnNav";

function PageLoading() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center font-mono text-sm text-black/40">
      <span className="animate-pulse">Загрузка...</span>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTopOnNav />
        <Suspense fallback={<PageLoading />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/tariffs" element={<TariffsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/cabinet" element={<CabinetPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/oferta" element={<OfferPage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/recurring" element={<RecurringInfoPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <CookieBanner />
      <MaxChatWidget />
    </div>
  );
}

export default App;
